import styled from 'styled-components';

var StyledSvg = styled.svg.withConfig({
  displayName: "StyledSvg",
  componentId: "sc-168fduh-0"
})(["width:100%;vertical-align:middle;pointer-events:none;overflow:hidden;"]);

export { StyledSvg };
